import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import FilterDropdown from '../molecules/FilterDropdown/views/FilterDropdown.view';
import StyledQuickFilterWrapper from '../styles/QuickFilters.styles';
import {
  getInitialValues,
  getQuickFilters,
} from '../../CategoryListingPage/container/CategoryListingPage.selectors';
import {
  getIsSizeGroupFilterEnabled,
  getQuickFiltersCount,
} from '../../../../../reduxStore/selectors/session.selectors';
import {
  CLOTHING_SIZE_FILTER,
  FIT_FILTER,
  PRICE_FILTER,
  SIZE_FILTER,
} from '../constants/QuickFilters.constants';

const QuickFilters = ({
  filterMaps = {},
  setUpdatedUrlActn,
  isFacetedNavigationEnabled,
  seoFacetedNavigationConfig,
  cleanUrlObj,
  pathName,
  formDetails,
  appliedFilters = {},
  quickFiltersCount,
  isSizeGroupFilterEnabled,
  quickFilters = {},
  setPriceFilterFlagActn,
  updateBopisFormValue,
  isPLPSortAndOneHrFilterRedesignEnabled,
}) => {
  const filterNames = filterMaps?.unbxdDisplayName;
  return (
    <StyledQuickFilterWrapper
      isPLPSortAndOneHrFilterRedesignEnabled={isPLPSortAndOneHrFilterRedesignEnabled}
    >
      {Object.keys(quickFilters)
        ?.filter((filter) => {
          if (filter === CLOTHING_SIZE_FILTER && !isSizeGroupFilterEnabled) return false;
          if (filter === SIZE_FILTER && isSizeGroupFilterEnabled) return false;
          if (filter === FIT_FILTER) return false;
          if (
            filter === PRICE_FILTER &&
            filterMaps &&
            filterMaps?.newPriceRange &&
            filterMaps?.newPriceRange?.min === filterMaps?.newPriceRange?.max
          )
            return false;
          return true;
        })
        ?.filter((_, idx) => idx < quickFiltersCount)
        ?.map((filter) => (
          <>
            {!isEmpty(quickFilters) &&
              Array.isArray(quickFilters[filter]) &&
              quickFilters[filter].length && (
                <FilterDropdown
                  key={`filterDropdown-${filter}`}
                  filterValues={quickFilters[filter]}
                  filterName={filterNames[filter]}
                  facetName={filter}
                  setUpdatedUrlActn={setUpdatedUrlActn}
                  isFacetedNavigationEnabled={isFacetedNavigationEnabled}
                  seoFacetedNavigationConfig={seoFacetedNavigationConfig}
                  cleanUrlObj={cleanUrlObj}
                  pathName={pathName}
                  formDetails={formDetails}
                  appliedFilters={appliedFilters}
                  filterMaps={filterMaps}
                  updateBopisFormValue={updateBopisFormValue}
                  setPriceFilterFlagActn={setPriceFilterFlagActn}
                />
              )}
          </>
        ))}
    </StyledQuickFilterWrapper>
  );
};

const mapStateToProps = (state) => ({
  initialValues: getInitialValues(state),
  quickFiltersCount: getQuickFiltersCount(state),
  isSizeGroupFilterEnabled: getIsSizeGroupFilterEnabled(state),
  quickFilters: getQuickFilters(state),
});

export default connect(mapStateToProps, null)(QuickFilters);
